import { Itinerary } from '../../types/Itinerary';

export const fetchCityTemplateAction = (citySlug: string) => {
  return {
    type: Actions.FETCH_CITY_ITINERARY_TEMPLATES,
    payload: { citySlug },
  };
};

export const setCityTemplateAction = (
  citySlug: string,
  itineraryTemplates: Itinerary[]
) => {
  return {
    type: Actions.FETCH_CITY_ITINERARY_TEMPLATES_SUCCESS,
    payload: { citySlug, itineraryTemplates },
  };
};

export const addItineraryTemplateAction = (template: Itinerary) => {
  return {
    type: Actions.ADD_ITINERARY_TEMPLATE,
    payload: { template },
  };
};

export const deleteItineraryTemplateAction = (id: string) => {
  return {
    type: Actions.DELETE_ITINERARY_TEMPLATE,
    payload: { id },
  };
};

export const updateItineraryTemplateAction = (
  id: string,
  fields: Partial<Itinerary>
) => {
  return {
    type: Actions.UPDATE_ITINERARY_TEMPLATE,
    payload: { id, fields },
  };
};

export enum Actions {
  FETCH_CITY_ITINERARY_TEMPLATES_SUCCESS = 'FETCH_CITY_ITINERARY_TEMPLATES_SUCCESS',
  FETCH_CITY_ITINERARY_TEMPLATES = 'FETCH_CITY_ITINERARY_TEMPLATES',
  UPDATE_ITINERARY_TEMPLATE = 'UPDATE_ITINERARY_TEMPLATE',
  DELETE_ITINERARY_TEMPLATE = 'DELETE_ITINERARY_TEMPLATE',
  ADD_ITINERARY_TEMPLATE = 'ADD_ITINERARY_TEMPLATE',
}
type FetchCityTemplateAction = {
  type: Actions.FETCH_CITY_ITINERARY_TEMPLATES;
  payload: { citySlug: string };
};
type FetchCityTemplateSuccessAction = {
  type: Actions.FETCH_CITY_ITINERARY_TEMPLATES_SUCCESS;
  payload: { citySlug: string; itineraryTemplates: Itinerary[] };
};

type AddItineraryTemplateAction = {
  type: Actions.ADD_ITINERARY_TEMPLATE;
  payload: { template: Itinerary };
};

type DeleteItineraryTemplateAction = {
  type: Actions.DELETE_ITINERARY_TEMPLATE;
  payload: { id: string };
};

type UpdateItineraryTemplateAction = {
  type: Actions.UPDATE_ITINERARY_TEMPLATE;
  payload: { id: string; fields: Partial<Itinerary> };
};

export type ActionType =
  | FetchCityTemplateAction
  | FetchCityTemplateSuccessAction
  | AddItineraryTemplateAction
  | DeleteItineraryTemplateAction
  | UpdateItineraryTemplateAction;
